import React from "react";

const PercentageDial = ({
  amount,
  totalAmount,
  title,
  estimatedRefillDate,
}: {
  amount: number;
  totalAmount?: number;
  title: string;
  estimatedRefillDate?: Date;
}) => (
  <div className="bg-white pt-3 pb-3 p-6 rounded-lg shadow">
    <div className="flex items-center">
      <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
        <span className="text-2xl font-bold text-blue-700">
          {amount?.toFixed(0) || 0}
          <span className="text-xs font-bold text-blue-700">
            {totalAmount ? `/ ${totalAmount}` : " % "}
          </span>
        </span>
      </div>
      <div className="ml-4">
        <h3 className="text-sm font-bold text-gray-900 tracking-wider">
          {title}
        </h3>
        {estimatedRefillDate && (
          <div className="text-xs text-gray-600 mt-1">
            est. refill {estimatedRefillDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' })}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default PercentageDial;
